import { render, staticRenderFns } from "./SendDetailDeli.vue?vue&type=template&id=12c87601&scoped=true&"
import script from "./SendDetailDeli.vue?vue&type=script&lang=js&"
export * from "./SendDetailDeli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c87601",
  null
  
)

export default component.exports